import { render } from "./DynamicToggle.vue?vue&type=template&id=0f556dec&scoped=true"
import script from "./DynamicToggle.vue?vue&type=script&lang=js"
export * from "./DynamicToggle.vue?vue&type=script&lang=js"

import "./DynamicToggle.vue?vue&type=style&index=0&id=0f556dec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f556dec"]])

export default __exports__